import './WaitingRoom.scoped.scss';
// import ImportantRooms from "../components/WaitingRoom/ImportantRooms";
import Members from '../components/WaitingRoom/Members';
import MyInfo from '../components/WaitingRoom/MyInfo';
import Rooms from '../components/WaitingRoom/Rooms';
import WaitingRoomHeader from '../components/WaitingRoom/WaitingRoomHeader';
import CreatingRoom from '../components/WaitingRoom/CreatingRoom/CreatingRoom';
import { useRecoilState } from 'recoil';
import waitingRoomState, {
  CheckingRoomPasswordStateType
} from '../atoms/waiting-room';
import EnteringSecretRoom from '../components/WaitingRoom/EnteringSecretRoom/EnteringSecretRoom';
import { useEffect } from 'react';
import emitGetMyInfo from '../connector/emits/getMyInfo';
import emitGetRooms from '../connector/emits/getRooms';
import emitGetUsers from '../connector/emits/getUsers';
import emitGetUserDetails from '../connector/emits/getUserDetails';
import participantsState from '../atoms/participants';

function WaitingRoom() {
  const [waitingRoom] = useRecoilState(waitingRoomState);
  const [participants] = useRecoilState(participantsState);

  useEffect(() => {
    emitGetMyInfo();
    emitGetUsers('square');
    emitGetRooms();
  }, []);

  useEffect(() => {
    emitGetUserDetails(participants.users);
  }, [participants.users]);

  useEffect(() => {
    if (
      waitingRoom.checkingRoomPasswordState ===
      CheckingRoomPasswordStateType.SUCCESS
    ) {
      window.location.href = `/chatting-app/room/${
        waitingRoom.tryingRoomId
      }?password=${waitingRoom.tryingEncryptedPassword}`;
    } else if (
      waitingRoom.checkingRoomPasswordState ===
      CheckingRoomPasswordStateType.FAILURE
    ) {
      window.alert('입력하신 패스워드가 올바르지 않습니다.');
    }
  }, [
    waitingRoom.checkingRoomPasswordState,
    waitingRoom.tryingEncryptedPassword,
    waitingRoom.tryingRoomId
  ]);

  return (
    <>
      <div className="waiting-room">
        <WaitingRoomHeader />
        <div className="waiting-room__contents">
          <div className="waiting-room__rooms">
            <div className="waiting-room__ad-banner-1">
              <img
                src="/img/banner/banner2.jpg"
              />
            </div>
            {/*<ImportantRooms />*/}
            <Rooms />
          </div>
          <div className="waiting-room__members">
            <MyInfo />
            <Members />
            <div className="waiting-room__ad-banner-2">
              <img
                src="/img/banner/banner1.jpg"
              />
            </div>
          </div>
        </div>
      </div>
      {waitingRoom.isOpenedEnteringSecretRoom ? <EnteringSecretRoom /> : null}
      {waitingRoom.isOpenedCreatingRoom ? <CreatingRoom /> : null}
      <div className="popup-footer">
        Copyright ⓒ <strong style={{color: '#127ccb'}}>BLACKCHIP365</strong> All Rights Reserved.
      </div>
    </>
  );
}

export default WaitingRoom;
